import { useContext, useMemo } from 'react';

import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { ExtranetPackStatus } from 'app/typings/core/extranet/hotel/packs';

export const useFilteredPacks = () => {
  const { packsList, publishedRooms } = useContext(ModernHotelContext);

  const sortedNightStayPacks = useMemo(() => {
    return packsList.filter((pack) => {
      const isPublishedOrUnpublished = [
        ExtranetPackStatus.PUBLISHED,
        ExtranetPackStatus.UNPUBLISHED,
      ].includes(pack.status);
      const isNightStay = !pack.isDaytime;

      const hasPublishedRoom = (pack.packRooms ?? []).some((packRoom) =>
        (publishedRooms ?? []).some((room) => room.id === packRoom.roomId)
      );

      return isPublishedOrUnpublished && isNightStay && hasPublishedRoom;
    });
  }, [packsList, publishedRooms]);

  const sortedDaytimePacks = useMemo(() => {
    return packsList.filter((pack) => {
      const isPublishedOrUnpublished = [
        ExtranetPackStatus.PUBLISHED,
        ExtranetPackStatus.UNPUBLISHED,
      ].includes(pack.status);
      const isDaytime = pack.isDaytime;

      return isPublishedOrUnpublished && isDaytime;
    });
  }, [packsList]);

  return { sortedNightStayPacks, sortedDaytimePacks };
};
